module.exports = __webpack_public_path__ + "img/zhiweb-propa.245df5a5.png";